/* HerSafe review carousel.
   A clone of the last slide sits before the first and a clone of the first
   after the last, so reaching either end slides in the same direction as every
   other move and then jumps onto the real slide with the transition off - the
   loop never plays a rewind. */
(function () {
  function init(root) {
    if (root.dataset.rvReady) return;
    root.dataset.rvReady = '1';

    var viewport = root.querySelector('.pt-rv__viewport');
    var track = root.querySelector('.pt-rv__track');
    if (!viewport || !track) return;

    var real = Array.prototype.slice.call(track.children);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fit(el) {
      if (!el) return;
      viewport.style.height = el.getBoundingClientRect().height + 'px';
    }

    if (real.length < 2) {
      root.classList.add('pt-rv--single');
      if (real[0]) fit(real[0]);
      return;
    }

    var head = real[real.length - 1].cloneNode(true);
    var tail = real[0].cloneNode(true);
    head.setAttribute('aria-hidden', 'true');
    tail.setAttribute('aria-hidden', 'true');
    track.insertBefore(head, real[0]);
    track.appendChild(tail);

    root.classList.add('pt-rv--multi');

    var slides = Array.prototype.slice.call(track.children);
    var last = slides.length - 1;
    var at = 1;
    var timer = null;
    var revealed = false;

    var DURATION = 450;                  // must match the CSS transition
    var settleTimer = null;

    // A clone is only ever a stopover. Whenever the index is sitting on one,
    // jump to the real slide it stands for, with the transition off.
    function settle() {
      if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
      if (at === 0) { at = last - 1; paint(true); }
      else if (at === last) { at = 1; paint(true); }
    }

    function paint(instant) {
      // never address a slide that is not there - recover to the first real
      // one instead, so a lost frame can never become a permanent blank card
      if (at < 0 || at > last || !slides[at]) {
        at = 1;
        instant = true;
      }
      if (instant) track.classList.add('is-instant');
      track.style.setProperty('--i', at);
      fit(slides[at]);
      if (instant) {
        void track.offsetWidth;          // force the frame before re-arming
        track.classList.remove('is-instant');
      }
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      root.classList.add('is-revealed');
    }

    function restart() {
      if (timer) clearInterval(timer);
      if (reduce || document.hidden) return;
      var ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      timer = setInterval(function () { go(1, false); }, ms);
    }

    // A hidden tab keeps firing intervals but runs no transitions, so moves
    // would stack up with nothing to finish them. Stop, and settle on return.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (timer) { clearInterval(timer); timer = null; }
      } else {
        settle();
        restart();
      }
    });

    function go(step, byUser) {
      settle();                          // finish any pending wrap first
      at += step;
      if (at < 0) at = last - 1;         // hard clamp, never out of range
      if (at > last) at = 1;
      paint(false);
      if (!byUser) reveal();
      restart();
      // transitionend is the fast path; this is the one that runs when the
      // transition never actually plays
      settleTimer = setTimeout(settle, DURATION + 150);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      if (e.target !== track) return;
      settle();
    });

    Array.prototype.forEach.call(root.querySelectorAll('.pt-rv__nav'), function (b) {
      b.addEventListener('click', function () {
        go(parseInt(b.getAttribute('data-go'), 10), true);
      });
    });

    // a real swipe, mapped through the page direction
    var dirSign = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      go(dx * dirSign < 0 ? 1 : -1, true);
    }, { passive: true });

    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    window.addEventListener('resize', function () { fit(slides[at]); });

    paint(true);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fit(slides[at]); });
    }
    restart();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.pt-rv[data-carousel]'), init);
    Array.prototype.forEach.call(document.querySelectorAll('.pt-rv--single'), function (root) {
      var s = root.querySelector('.pt-rv__slide');
      var v = root.querySelector('.pt-rv__viewport');
      if (s && v) v.style.height = s.getBoundingClientRect().height + 'px';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // the theme editor re-renders the block on every setting change
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:block:select', boot);
})();
